import { createRouter } from "@tanstack/react-router";
import { queryClient } from "~/queryClient";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  context: {
    queryClient,
  },
  pathParamsAllowedCharacters: [":"],
  routeTree,
  trailingSlash: "never",
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
